/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockOrderCheckInfoOrderCheckGoodsVo
 */
export interface StockOrderCheckInfoOrderCheckGoodsVo {
    /**
     * 商品检查单ID
     * @type {number}
     * @memberof StockOrderCheckInfoOrderCheckGoodsVo
     */
    checkOrderId?: number;
    /**
     * 商品编码
     * @type {string}
     * @memberof StockOrderCheckInfoOrderCheckGoodsVo
     */
    goodsCode?: string;
    /**
     * 商品名称
     * @type {string}
     * @memberof StockOrderCheckInfoOrderCheckGoodsVo
     */
    goodsName?: string;
    /**
     * 商品颜色
     * @type {string}
     * @memberof StockOrderCheckInfoOrderCheckGoodsVo
     */
    goodsColor?: string;
    /**
     * 商品尺寸
     * @type {string}
     * @memberof StockOrderCheckInfoOrderCheckGoodsVo
     */
    goodsSize?: string;
    /**
     * 商品错误数量
     * @type {number}
     * @memberof StockOrderCheckInfoOrderCheckGoodsVo
     */
    goodsErrorQuantity?: number;
    /**
     * 商品错误状态名
     * @type {string}
     * @memberof StockOrderCheckInfoOrderCheckGoodsVo
     */
    goodsErrorStatusName?: string;
    /**
     * 商品单价
     * @type {number}
     * @memberof StockOrderCheckInfoOrderCheckGoodsVo
     */
    goodsUnitPrice?: number;
    /**
     * 商品入库条码
     * @type {string}
     * @memberof StockOrderCheckInfoOrderCheckGoodsVo
     */
    marketBarcode?: string;
    /**
     * 入库商品名
     * @type {string}
     * @memberof StockOrderCheckInfoOrderCheckGoodsVo
     */
    marketProNm?: string;
    /**
     * 商品选项名
     * @type {string}
     * @memberof StockOrderCheckInfoOrderCheckGoodsVo
     */
    marketOptionName?: string;
    /**
     * 商品图片URL
     * @type {string}
     * @memberof StockOrderCheckInfoOrderCheckGoodsVo
     */
    imgUrl?: string;
    /**
     * 构成
     * @type {number}
     * @memberof StockOrderCheckInfoOrderCheckGoodsVo
     */
    constructCount?: number;
    /**
     * skuId
     * @type {number}
     * @memberof StockOrderCheckInfoOrderCheckGoodsVo
     */
    skuId?: number;
    /**
     * sku编码
     * @type {string}
     * @memberof StockOrderCheckInfoOrderCheckGoodsVo
     */
    skuCode?: string;
    /**
     * 购买类型 1 代买服务 2 转运服务
     * @type {number}
     * @memberof StockOrderCheckInfoOrderCheckGoodsVo
     */
    buyType?: number;
}

/**
 * Check if a given object implements the StockOrderCheckInfoOrderCheckGoodsVo interface.
 */
export function instanceOfStockOrderCheckInfoOrderCheckGoodsVo(value: object): value is StockOrderCheckInfoOrderCheckGoodsVo {
    return true;
}

export function StockOrderCheckInfoOrderCheckGoodsVoFromJSON(json: any): StockOrderCheckInfoOrderCheckGoodsVo {
    return StockOrderCheckInfoOrderCheckGoodsVoFromJSONTyped(json, false);
}

export function StockOrderCheckInfoOrderCheckGoodsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockOrderCheckInfoOrderCheckGoodsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'checkOrderId': json['checkOrderId'] == null ? undefined : json['checkOrderId'],
        'goodsCode': json['goodsCode'] == null ? undefined : json['goodsCode'],
        'goodsName': json['goodsName'] == null ? undefined : json['goodsName'],
        'goodsColor': json['goodsColor'] == null ? undefined : json['goodsColor'],
        'goodsSize': json['goodsSize'] == null ? undefined : json['goodsSize'],
        'goodsErrorQuantity': json['goodsErrorQuantity'] == null ? undefined : json['goodsErrorQuantity'],
        'goodsErrorStatusName': json['goodsErrorStatusName'] == null ? undefined : json['goodsErrorStatusName'],
        'goodsUnitPrice': json['goodsUnitPrice'] == null ? undefined : json['goodsUnitPrice'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'constructCount': json['constructCount'] == null ? undefined : json['constructCount'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'buyType': json['buyType'] == null ? undefined : json['buyType'],
    };
}

export function StockOrderCheckInfoOrderCheckGoodsVoToJSON(json: any): StockOrderCheckInfoOrderCheckGoodsVo {
    return StockOrderCheckInfoOrderCheckGoodsVoToJSONTyped(json, false);
}

export function StockOrderCheckInfoOrderCheckGoodsVoToJSONTyped(value?: StockOrderCheckInfoOrderCheckGoodsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'checkOrderId': value['checkOrderId'],
        'goodsCode': value['goodsCode'],
        'goodsName': value['goodsName'],
        'goodsColor': value['goodsColor'],
        'goodsSize': value['goodsSize'],
        'goodsErrorQuantity': value['goodsErrorQuantity'],
        'goodsErrorStatusName': value['goodsErrorStatusName'],
        'goodsUnitPrice': value['goodsUnitPrice'],
        'marketBarcode': value['marketBarcode'],
        'marketProNm': value['marketProNm'],
        'marketOptionName': value['marketOptionName'],
        'imgUrl': value['imgUrl'],
        'constructCount': value['constructCount'],
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'buyType': value['buyType'],
    };
}

